import { Box, Button, Card, CardContent, CardHeader, Divider, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import FormController from '../../form_v2/highLevelComponents/FormController';
import FormActionButtonLayout from '../../layout/Form/FormActionButtonLayout';
import FormLayout from '../../layout/Form/FormLayout';
import * as Yup from 'yup';
import { FilterComponentProps } from '../TableGridWithFilters/type';
import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';
import { useTranslation } from 'react-i18next';
import React from 'react';

const FilterComponentV2 = ({
  title,
  showDivider = true,
  initialValues = {},
  filterFields = [],
  changeFilters,
  resetFilters = false,
  resetFiltersTo = initialValues,
  validationSchema = Yup.object({}),
  showCard = true,
  oneLiner = false, // filterFields need to be an Array of length 1 in addition to oneLiner = true. Search Button will be on the same row with filerFields.
  mode,
  showTitle = true,
  onResetFunction,
  ...rest
}: FilterComponentProps) => {

  const onSubmit = (formik: any) => {
    changeFilters(formik.values);
  };

  const onReset = (formik: any) => {
    onResetFunction && onResetFunction();
    Object.keys(formik.values).map((value) => {
      formik.setFieldValue(value, resetFiltersTo[value]);
    });
  };

  const { t } = useTranslation();
  return (
    <>
      <Formik
        {...rest}
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSubmit({ values });
        }}
      >
        {formik =>
          (<>
            <ConditionalWrapper condition={showCard}
              wrapper={(children) =>
                <Card style={{ backgroundColor: 'transparent' }} elevation={3}>
                  <CardHeader title={
                    title
                      ? <>
                        <Typography variant='h3' m={2}>
                          {title}
                        </Typography>
                        {showDivider && <Divider variant='fullWidth' />}
                      </>
                      : null

                  }>
                  </CardHeader>
                  <CardContent sx={{ overflowX: 'auto' }}>
                    {children}
                  </CardContent>
                </Card>
              }>
              <>
                {!showCard && showTitle &&
                <Typography variant='h3' m={2}>
                  {title}
                </Typography>
                }
                {(showDivider && !showCard) && <Divider variant='fullWidth' />}
                <Form>
                  <FormLayout>
                    {filterFields.map((el: any, index:number) => {
                      if (React.isValidElement(el)) {
                        return el;
                      }
                      if (Array.isArray(el)) {
                        return <Box display='flex'
                          alignContent='center'
                          alignItems='center'
                          gap={3}
                          key={index + 'Box'}>
                          {el.map((subEl) => {
                            return (
                              <div
                                style={
                                  subEl.hidden
                                    ? { display: 'none' }
                                    : { width: '100%' }
                                }
                                key={subEl.name}
                              >
                                <FormController
                                  {...subEl}
                                  formik={formik}
                                />
                              </div>
                            );
                          })}
                          {(filterFields.length === 1 && oneLiner)
                            ? <>
                              {resetFilters
                                ? <Button variant='outlined'
                                  onClick={() => onReset(formik)}
                                  style={{ gap: 1, borderRadius: 24, maxWidth: '150px', maxHeight: '50px', minWidth: '150px', minHeight: '50px' }}>
                                  {t('Καθαρισμός')} </Button>
                                : null
                              }
                              <Button variant='contained' type='submit'
                                style={{
                                  gap: 1, borderRadius: 24, maxWidth: '150px', maxHeight: '50px', minWidth: '150px', minHeight: '50px' }}>
                                {mode === 'create'
                                  ? t('Δημιουργία')
                                  : t('Αναζήτηση')
                                }
                              </Button>
                            </>
                            : null
                          }
                        </Box>;
                      }
                      return (
                        <FormController
                          key={el.name}
                          formik={formik}
                          {...el}
                        />);
                    })}
                  </FormLayout>
                  {!oneLiner &&
                  <FormActionButtonLayout>
                    {resetFilters
                      ? <Button variant='outlined'
                        onClick={() => onReset(formik)}
                        style={{
                          gap: 1, borderRadius: 24, maxWidth: '150px', maxHeight: '50px', minWidth: '150px', minHeight: '50px' }}>
                        {t('Καθαρισμός')}</Button>
                      : null
                    }
                    <Button variant='contained' type='submit'
                      style={{
                        gap: 1, borderRadius: 24, maxWidth: '150px', maxHeight: '50px', minWidth: '150px', minHeight: '50px' }}>
                      {mode === 'create'
                        ? t('Δημιουργία')
                        : t('Αναζήτηση')
                      }
                    </Button>
                  </FormActionButtonLayout>
                  }
                </Form>
              </>
            </ConditionalWrapper>
          </>)
        }
      </Formik>
    </>
  );
};

export default FilterComponentV2;